import {TextField} from "@material-ui/core";
import React, {useState} from "react";
import {Constants} from "../constants/Constants";
import UsersManager from "../managers/UsersManager";

export default function ClientSeedTextField() {

    const loggedInUser = UsersManager.getLoggedInUser() ? JSON.parse(UsersManager.getLoggedInUser() as string) : {};
    const [clientSeed, setClientSeed] = useState(localStorage.getItem(Constants.USER_CLIENT_SEED) ?? loggedInUser["activeClientSeed"]);

    const handleClientSeedChange = (event: any) => {
        let newClientSeed = event.target.value;
        setClientSeed(newClientSeed);
        localStorage.setItem(Constants.USER_CLIENT_SEED, newClientSeed);
    }

    return <TextField
        onChange={handleClientSeedChange}
        value={clientSeed}
        variant={"outlined"}
        size={"small"}
        style={{
            fontStyle: 'bold',
            fontWeight: 600,
        }}/>

}